<template>
    <div v-if="showCover" class="reverse-orientation-cover">
        <div class="reverse-orientation-cover-msg">
            <img
                src="/images/transfer-avatar-modal/logo.svg"
                alt="logo"
                class="cover-logo"
            />
            <span><slot>Rotate your device to play</slot></span>
            <a @click="dismissCover">Close</a>
        </div>
    </div>
</template>

<script>
import { MobileScreenWidthDetect } from '@/core/mixins/MobileScreenWidthDetect.js';

export default {
    mixins: [MobileScreenWidthDetect],
    data() {
        return {
            coverDismissed: !!sessionStorage.getItem('flipReverseCover'),
        };
    },
    computed: {
        showCover() {
            return (
                this.isMobileScreenDimensions &&
                this.isLandscape &&
                !this.coverDismissed
            );
        },
    },
    methods: {
        dismissCover() {
            sessionStorage.setItem('flipReverseCover', 'true');
            this.coverDismissed = true;
        },
    },
};
</script>

<style scoped lang="scss">
.reverse-orientation-cover {
    position: fixed;
    inset: 0;
    z-index: 9000;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: #ae8dda;
}
.reverse-orientation-cover-msg {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
    animation: rotateMsg 1s ease-out 0.5s;
    animation-fill-mode: forwards;

    span {
        font-size: 20px;
        font-weight: bold;
        text-shadow: -1px 1px black;
    }

    a {
        opacity: 0;
        animation: revealClose 0.2s ease-out 2s;
        animation-fill-mode: forwards;
    }
}
@keyframes rotateMsg {
    to {
        transform: rotate(-90deg);
    }
}
@keyframes revealClose {
    to {
        opacity: 0.6;
    }
}
.cover-logo {
    width: 105px;
}
</style>
